import { render, staticRenderFns } from "./RoleConfirm.vue?vue&type=template&id=44acf7a4"
import script from "./RoleConfirm.vue?vue&type=script&lang=js"
export * from "./RoleConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports